import { handleActions, combineActions } from 'redux-actions'
import * as rawActions from '../actions'

const defaultState = false

export default handleActions(
  {
    [rawActions.reset](state, action) {
      return defaultState
    },
    [combineActions(
      rawActions.getLatestPoliciesWithAcceptanceStatusSuccess,
      rawActions.getLatestPolicySuccess,
      rawActions.getPolicySuccess
    )](state, action) {
      return true
    },
    [combineActions(
      rawActions.getLatestPoliciesWithAcceptanceStatusRequest,
      rawActions.getLatestPoliciesWithAcceptanceStatusFailed,
      rawActions.getLatestPolicyRequest,
      rawActions.getLatestPolicyFailed,
      rawActions.getPolicyRequest,
      rawActions.getPolicyFailed
    )](state, action) {
      return false
    },
  },
  defaultState
)
